// src/services/userApiService.js
import axios from "axios";

import { getApiBaseUrl } from "./getApiBaseUrl";

const userApiService = axios.create({
  baseURL: getApiBaseUrl(),
  headers: {
    "Content-Type": "application/json"
  }
});

// Request interceptor to include Bearer token
userApiService.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("accessToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default userApiService;
